"use client";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Button as MuiButton } from "@mui/material";
import Link from "next/link";
import { FC } from "react";
import { ButtonLoader } from "../../Loaders";
import { ButtonProps } from "../lib/type";
import { isString } from "lodash";

const CustomLink = ({ children, href = "", ...props }: any) => (
  <Link {...props} href={href} prefetch={false}>
    {children}
  </Link>
);

export const Button: FC<ButtonProps> = ({
  variant = "contained",
  size = "large",
  className,
  startIcon,
  loading,
  disabled,
  buttonLoaderClassName,
  LinkComponent = Link,
  href,
  type,
  prefetch,
  ...rest
}) => {
  return (
    <MuiButton
      variant={variant}
      size={size}
      disabled={disabled || loading}
      startIcon={
        loading ? (
          <ButtonLoader size={size} className={buttonLoaderClassName} />
        ) : (
          startIcon
        )
      }
      LinkComponent={CustomLink}
      href={isString(href) ? href : undefined}
      className={cn(className)}
      type={isString(href) ? (null as unknown as undefined) : type}
      {...rest}
    />
  );
};
